import React from "react";
import {
  Plus,
  PencilSimple,
  Trash,
  Star,
  UserCircle,
  EnvelopeSimple,
  Phone,
} from "@phosphor-icons/react";

export default function ContactsTab({
  contacts,
  onAdd,
  onEdit,
  onDelete,
  onSetPrimary,
}) {
  return (
    <div className="bg-white border border-slate-200 rounded-lg">
      <div className="px-6 py-4 border-b border-slate-200 flex items-center justify-between">
        <h3 className="font-heading font-semibold text-slate-900">
          Customer Contacts
        </h3>
        <button
          onClick={onAdd}
          data-testid="add-contact-button"
          className="inline-flex items-center gap-2 px-3 h-9 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700"
        >
          <Plus size={16} weight="bold" /> Add Contact
        </button>
      </div>
      {contacts.length === 0 ? (
        <div className="px-6 py-12 text-center text-sm text-slate-500">
          No contacts yet. Add team members, decision makers, or alternate emails.
        </div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {contacts.map((c) => (
            <li
              key={c.id}
              className="px-6 py-4 flex items-start justify-between gap-4"
              data-testid={`contact-row-${c.id}`}
            >
              <div className="flex items-start gap-3 min-w-0 flex-1">
                <div className="w-10 h-10 bg-blue-50 text-blue-700 rounded-full flex items-center justify-center shrink-0">
                  <UserCircle size={22} weight="duotone" />
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-medium text-slate-900">{c.name}</span>
                    {c.is_primary && (
                      <span
                        className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold text-amber-700 bg-amber-50 px-2 py-0.5 rounded-full"
                        data-testid={`primary-badge-${c.id}`}
                      >
                        <Star size={10} weight="fill" /> Primary
                      </span>
                    )}
                    {c.role && (
                      <span className="text-xs text-slate-500">· {c.role}</span>
                    )}
                  </div>
                  <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-sm text-slate-600">
                    {c.email && (
                      <a
                        href={`mailto:${c.email}`}
                        className="inline-flex items-center gap-1.5 hover:text-blue-600"
                      >
                        <EnvelopeSimple size={14} /> {c.email}
                      </a>
                    )}
                    {c.phone && (
                      <a
                        href={`tel:${c.phone}`}
                        className="inline-flex items-center gap-1.5 hover:text-blue-600"
                      >
                        <Phone size={14} /> {c.phone}
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-1">
                {!c.is_primary && (
                  <button
                    onClick={() => onSetPrimary(c.id)}
                    className="p-2 rounded-md text-slate-500 hover:text-amber-600 hover:bg-amber-50"
                    title="Set as primary"
                    data-testid={`set-primary-${c.id}`}
                  >
                    <Star size={16} />
                  </button>
                )}
                <button
                  onClick={() => onEdit(c)}
                  className="p-2 rounded-md text-slate-500 hover:text-blue-600 hover:bg-slate-50"
                  data-testid={`edit-contact-${c.id}`}
                >
                  <PencilSimple size={16} />
                </button>
                <button
                  onClick={() => onDelete(c.id)}
                  className="p-2 rounded-md text-slate-500 hover:text-red-600 hover:bg-red-50"
                  data-testid={`delete-contact-${c.id}`}
                >
                  <Trash size={16} />
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
